module.exports = __webpack_public_path__ + "static/media/servicios_regulacionSanitaria.d75dfbd2.jpg";